var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-icon logout-icon"},[_c('button',{on:{"click":_vm.logout}},[_c('font-awesome-icon',{attrs:{"icon":"lock"}}),_c('p',[_vm._v("Log Out")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }